// ==================== GURUKUL — "My LMS access" for volunteers (REQUIREMENTS_REGISTER GUR-15) ====================
// Status of the volunteer's own LMS account request (raised automatically when they signed onboarding) and the
// reveal-once login details. Mirrors the parent's "LMS access" page in gurukul-lms.js.
import { showToast, showConfirm } from '../components/toasts.js';

function esc(text) {
  return String(text ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
async function api(path, options = {}) {
  const res = await fetch(path, { credentials: 'include', headers: { 'Content-Type': 'application/json' }, ...options });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}
const fmtDate = d => d ? new Date(d).toLocaleDateString() : '—';
const STATUS = {
  waiting: ['Waiting to be sent to the LMS Team', 'badge-warning'], failed: ['Needs attention from an admin', 'badge-danger'],
  open: ['With the LMS Team', 'badge-info'], wip: ['LMS Team is working on it', 'badge-info'],
  closed: ['Ready', 'badge-success'], cancelled: ['Cancelled', 'badge-danger'],
};
const statusBadge = s => { const [t, c] = STATUS[s] || [s, 'badge-info']; return `<span class="badge ${c}">${esc(t)}</span>`; };

export function getVolunteerLmsAccessPage() {
  return `<h1 class="page-title">My LMS access</h1><div id="gkVolLmsBox"><p class="empty-state">Loading…</p></div>`;
}

export async function initVolunteerLmsAccessPage() {
  const box = document.getElementById('gkVolLmsBox');
  let d;
  try { d = await api('/api/gurukul/volunteer-lms-access'); }
  catch (err) { box.innerHTML = `<p class="empty-state">${esc(err.message)}</p>`; return; }

  if (!d.volunteer) {
    box.innerHTML = '<div class="card"><p class="page-intro">This page is for volunteers who have signed the volunteer onboarding documents. Sign up first to get an LMS account.</p></div>';
    return;
  }
  if (!d.request) {
    box.innerHTML = `<div class="card"><h2>${esc(d.volunteer.volunteer_no)}</h2><p class="page-intro">No LMS account request yet — this is created automatically when you sign your volunteer onboarding.</p></div>`;
    return;
  }
  const r = d.request;
  box.innerHTML = `
    <div class="card"><h2>${esc(d.volunteer.volunteer_no)} — LMS account</h2>
      <p class="page-intro">The LMS Team creates the account. When it is ready you get a message, and the login details appear here. Only you can see them, and each view is recorded.</p>
      <div class="table-container"><table class="table-stack-mobile"><thead><tr><th>Request</th><th>Asked on</th><th>Status</th><th></th></tr></thead><tbody>
        <tr><td data-label="Request">${esc(r.item_no || '—')}</td><td data-label="Asked on">${fmtDate(r.created_at)}</td>
          <td data-label="Status">${statusBadge(r.status)}${r.closed_at ? '<br><small>' + fmtDate(r.closed_at) + '</small>' : ''}</td>
          <td data-label="" class="action-buttons">${r.can_view_details ? `<button type="button" id="gkVolLmsShow" data-id="${r.id}">Show login details</button><div id="gkVolLmsOut"></div>` : ''}</td></tr>
      </tbody></table></div>
    </div>`;
  const showBtn = box.querySelector('#gkVolLmsShow');
  if (showBtn) showBtn.addEventListener('click', async () => {
    if (!(await showConfirm('Show the login details? This view is recorded.'))) return;
    try {
      const s = await api('/api/gurukul/volunteer-lms-access', { method: 'POST', body: JSON.stringify({ action: 'reveal', request_id: showBtn.dataset.id }) });
      const out = box.querySelector('#gkVolLmsOut');
      out.innerHTML = `<div style="margin-top:8px;padding:8px 10px;border:1px solid var(--border);border-radius:6px;">
        <div>Login ID: <strong>${esc(s.login_id)}</strong></div><div>Temporary password: <code>${esc(s.password)}</code></div>
        <small>Change this password the first time you log in to the LMS.</small></div>`;
      showBtn.style.display = 'none';
      setTimeout(() => { out.innerHTML = ''; showBtn.style.display = ''; }, 60000);
    } catch (err) { showToast(err.message, 'error'); }
  });
}
